<template>
    <div class="mt-15">
        <div class="section-indicator-div">
            <div class="section-indicator-heading">
                <div class="section-indicator-title-container">
                    <div class="section-indicator-title-text">
                        Section {{ index + 1 }} of {{ totalSection }}
                    </div>
                </div>
            </div>
        </div>
        <div id="section-container" @click="makeCardEditable('section', index)" class="quiz-card col-12 shadow-sm">
            <div v-show="currentlyEditingCardType==='section' && currentlyEditingCardIndex === index"
                 class="editing-indicator-for-section"></div> <!-- Editing indicator -->
            <div class="flex-column" style="padding: 24px">
                <div @click="makeEditable('' , index)">
                    <FormElementWithoutLabel
                        :error="error.title"
                    >
                        <input :id="`section_${index}_title`"
                               type="text"
                               placeholder="Title (optional)"
                               :ref="`section_${index}_title`"
                               v-model="section.title"
                               class="form-control">
                    </FormElementWithoutLabel>
                </div>

                <div @click="makeEditable('section' + index, index)">
                    <div v-if="currentlyEditingItemIndex === index && currentlyEditingItemType === 'section' + index">
                        <SummerNote
                            :index="`${index}`"
                            :error="error.body"
                            :on-change-content="onChangeContent"
                            for-type="passage_for_section"
                            :content=section.body
                        >
                        </SummerNote>
                    </div>
                    <div v-else>
                        <div class="show-section-desc">
                            <p v-html="section.body === '' ? 'Description (Optional)' : section.body"></p>
                        </div>
                        <small class="invalid-feedback d-block"
                               v-show="error.body">
                            {{ error.body }}
                        </small>
                    </div>
                </div>

                <div class="mt-20 mb--20">
                    <FormElementWithoutLabel>
                        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-success">
                            <input
                                :id="`show_section_description_on_each_question_${index}`"
                                type="checkbox"
                                v-model="section.settings.show_section_description_on_each_question">
                            <label :for="`show_section_description_on_each_question_${index}`" class="pl-20 pt-10">
                                Show section description on each question in this section
                            </label>
                        </div>
                    </FormElementWithoutLabel>
                </div>


            </div>
            <div class="section-card-footer">
                <div class="section-card-footer-left-empty"></div>
                <div class="section-card-footer-right-button-container">
                    <button class="btn btn-md bg-transparent" title="Duplicate Section Below"
                            @click="hasEditPermission ? duplicateSection(index) : unableToAddOrDeleteMsg()"><i
                        class="fa-solid fa-copy"></i></button>
                    <button class="btn btn-md bg-transparent" title="Add Section"
                            @click="hasEditPermission ? addSection(index+1) : unableToAddOrDeleteMsg()"><i
                        class="fa-solid fa-folder-plus"></i></button>
                    <button class="btn btn-md bg-transparent" title="Delete Section"
                            @click="hasEditPermission ? confirmSectionRemoval() : unableToAddOrDeleteMsg()"><i
                        class="fa-solid fa-trash-can"></i></button>
                    <button v-show="index > 0" title="Move section up" class="btn btn-md bg-transparent"
                            @click="swapSection(index, index-1)"><i class="fa-solid fa-arrow-up"></i></button>
                    <button v-show="index < totalSection - 1" title="Move section down"
                            class="btn btn-md bg-transparent" @click="swapSection(index, index+1)"><i
                        class="fa-solid fa-arrow-down"></i></button>
                </div>

            </div>
        </div>
    </div>

    <VueDraggable ref="qu" tag="div" v-model="section.questions" handle=".drag-handler">
        <div v-for="(question, question_index) in section.questions" :key="question_index">
            <Question
                :index="question_index"
                :section-index="index"
                :make-editable="makeEditable"
                :make-card-editable="makeCardEditable"
                :currently-editing-item-type="currentlyEditingItemType"
                :currently-editing-item-index="currentlyEditingItemIndex"
                :currently-editing-card-index="currentlyEditingCardIndex"
                :currently-editing-card-type="currentlyEditingCardType"
                :question="question.question"
                :has-edit-permission="hasEditPermission"
                :unable-to-add-or-delete-msg="unableToAddOrDeleteMsg"
                :error="question.error"
                :add-question="addQuestion"
                :duplicate-question="duplicateQuestion"
                :remove-question="removeQuestion">

            </Question>
        </div>
    </VueDraggable>
</template>
<script>
export default {
    props: {
        section: {
            type: Object,
            required: true
        },
        currentlyEditingItemType: {
            type: String,
            required: true,
        },
        currentlyEditingItemIndex: {
            type: Number,
            required: true
        },
        currentlyEditingCardType: {
            type: String,
            required: true,
        },
        currentlyEditingCardIndex: {
            type: Number,
            required: true
        },
        error: {
            type: Object,
            required: false,
        },
        index: {
            type: Number,
            required: true,
        },
        addSection: {
            type: Function,
            required: true,
        },
        duplicateSection: {
            type: Function,
            required: true,
        },
        makeEditable: {
            type: Function,
            required: true
        },
        makeCardEditable: {
            type: Function,
            required: true
        },
        removeSection: {
            type: Function,
            required: true,
        },
        totalSection: {
            type: Number,
            required: false,
        },
        swapSection: {
            type: Function,
            required: false
        },
        hasEditPermission: {
            type: Boolean,
            required: true,
        },
    },
    mounted() {
        this.$refs[`section_${this.index}_title`].focus();
    },
    methods: {
        addQuestion(index) {
            this.section.questions.splice(index, 0,
                {
                    question: {
                        title: '',
                        body: '',
                        answer_type: 'mcq',
                        is_answer_case_sensitive: false,
                        correct_points: 1.00,
                        incorrect_points: 0.00,
                        unanswered_points: 0.00,
                        options: [{
                            option: {
                                title: '',
                                body: '',
                                is_correct: false
                            },
                            error: {
                                title: '',
                                body: '',
                                is_correct: ''
                            }
                        }]
                    },
                    error: {
                        title: '',
                        body: '',
                        answer_type: '',
                        correct_points: '',
                        incorrect_points: '',
                        unanswered_points: '',
                    }
                }
            )
            this.makeEditable('question' + this.index + '_' + index, index)
            this.makeCardEditable('question' + this.index, index)
        },
        duplicateQuestion(index) {
            const clonedQuestion = JSON.parse(JSON.stringify(this.section.questions[index]));

            clonedQuestion.question.id = null
            clonedQuestion.question.options = collect().unwrap(
                collect(clonedQuestion.question.options).map((option) => {
                    option.option.id = null

                    return option
                })
            )

            this.section.questions.splice(index + 1, 0, clonedQuestion)
            this.makeEditable('question' + this.index + '_' + index + 1, index + 1)
            this.makeCardEditable('question' + this.index, index + 1)
        },
        removeQuestion(index) {
            if (this.section.questions.length > 1) {
                this.section.questions.splice(index, 1);
            }
        },

        onChangeContent(content) {
            this.section.body = content
        },
        confirmSectionRemoval() {
            Swal.fire(
                {
                    title: "Delete Section?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#f2353c",
                    confirmButtonText: "Yes, delete!",
                }
            ).then(result => {
                if (result.isConfirmed) {
                    this.removeSection(this.index);
                }
            });
        },
        unableToAddOrDeleteMsg() {
            Swal.fire(
                {
                    title: "Error",
                    html:
                        '<p>This quiz is already associated with course activity. </p>' +
                        '<p>You can not <span style="color:red; font-weight: bold;">add or delete</span> anything. </p>' +
                        '<p>To do this you can <span style="color: green; font-weight: bold;">duplicate</span>  this quiz.</p>',
                    icon: "warning",
                    confirmButtonColor: "#f2353c",
                    confirmButtonText: "Ok!",
                }
            )
        }
    }
}
</script>
<script setup>
import SummerNote from "../../../components/SummerNote.vue";
import Question from "./Question.vue";
import FormElementWithoutLabel from "../../../components/FormElementWithoutLabel.vue";
import {VueDraggable} from "vue-draggable-plus";
</script>

<style scoped>

.section-indicator-div {
    display: block;
}

.editing-indicator-for-section {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 5px;
    background-color: #32CD32; /* Green color */
    border-bottom-left-radius: 10px;
}

.section-indicator-heading {
    -webkit-box-align: stretch;
    -webkit-align-items: stretch;
    align-items: stretch;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    flex-grow: 1;
}

.section-indicator-title-container {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-color: #007bff;
    color: rgba(255, 255, 255, 1);
}

.section-indicator-title-text {
    font-family: Roboto, Arial, sans-serif;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: .2px;
    line-height: 20px;
    padding: 8px 16px;
}

.header {
    border-bottom: 1px solid black;
}

.header-question {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.header-btn {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    max-height: 55px;
}

.section-card-footer {
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    border-top: 1px solid #dadce0;
    height: 64px;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    margin: 0 24px;
}

.section-card-footer-left-empty {
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    left: -12px;
    overflow: hidden;
    position: relative;
}

.section-card-footer-right-button-container {
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
}

.show-section-desc {
    width: 100%;
    height: 100%;
    border-bottom: 2px solid
}
</style>